import {
  IUmrahSearchParams,
  IUmrahSearchQueryArgs,
  IUmrahSearchQueryParams,
} from "../types/umrah-search-type";

function parseNumber(value: unknown): number | undefined {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}

function parseCsv(value?: string) {
  if (!value) {
    return [];
  }

  return value
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
}

export function encodedUmrahParams(data: IUmrahSearchQueryParams): string {
  const params = new URLSearchParams();

  if (typeof data.min_price === "number") {
    params.set("min_price", String(data.min_price));
  }

  if (typeof data.max_price === "number") {
    params.set("max_price", String(data.max_price));
  }

  if (data.duration?.length) {
    params.set("duration", data.duration.join(","));
  }

  if (data.group_size?.length) {
    params.set("group_size", data.group_size.join(","));
  }

  if (data.query?.trim()) {
    params.set("query", data.query.trim());
  }

  return params.toString();
}

export function decodedUmrahParams(
  params: IUmrahSearchParams,
): IUmrahSearchQueryParams {
  return {
    min_price: parseNumber(params.min_price),
    max_price: parseNumber(params.max_price),
    duration: parseCsv(params.duration),
    group_size: parseCsv(params.group_size),
    query: params.query?.trim() || undefined,
  };
}

export function toUmrahSearchQueryArgs(
  data: IUmrahSearchQueryParams,
): IUmrahSearchQueryArgs {
  return {
    searchParams: data,
  };
}
